import React from 'react';
import { Nav, Navbar, Dropdown } from 'rsuite';
import LegacyUserIcon from "@rsuite/icons/legacy/User";
import LegacyExchangeIcon from "@rsuite/icons/legacy/Exchange";
import LegacyPowerOffIcon from "@rsuite/icons/legacy/PowerOff";
import 'rsuite/dist/rsuite.min.css'
import Notification from './Notifications';
import AuthService from "../../../services/auth.service"
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

function TopNav() {
    const push = useNavigate();

    const logout = () => {
        AuthService.logout();
        window.location.href = "/";
    }
    const askLola = () => {
        push("/internal/askLola")
    }
    const userProfile = () => {
        push("/internal/userProfile")
    }
    const switchAccount = () => {
        push("/switchAccount")
    }
    const name = useSelector(x => x.userInfo.FormattedName);
    return (
        <div className='topnav'>
            <Navbar className='content'>
                <Navbar.Body>
                    <Nav pullRight>
                        <Notification />
                            <Dropdown placement="bottomEnd" title={name} trigger="hover">
                            <Dropdown.Item onSelect={() => { switchAccount() }} icon={<LegacyExchangeIcon />}>Switch Accounts</Dropdown.Item>
                            <Dropdown.Item onSelect={() => { userProfile() }} icon={<LegacyUserIcon />}>User Profile</Dropdown.Item>
                            {/*<Dropdown.Item onSelect={() => {askLola()}} icon={<Icon icon="comments" />}>Ask LOLA</Dropdown.Item>*/}
                            <Dropdown.Item icon={<LegacyPowerOffIcon />} onSelect={logout}>Logout</Dropdown.Item>
                            </Dropdown>
                    </Nav>
                    </Navbar.Body>            
        </Navbar>
        </div>
    );
}

export default TopNav;